import type { LoaderFunction } from 'react-router-dom'

import Player from '../Player/Player'

import allTrackData from '../../data/allTrackData'

export interface LoaderData {
  doneLoading?: true,
  soundCloudTrackId: number,
  sentencesUrl: string,
}

export const loader: LoaderFunction = async function trackLoader ({ params }) : Promise<LoaderData> {
  const { artist, album, track } = params

  const { soundCloudTrackId } = allTrackData[artist!].albums[album!].tracks[track!]
  const sentencesUrl = `/lyrics/${artist}/${album}/${track}/sentences.txt`

  return {
    doneLoading: true,
    soundCloudTrackId,
    sentencesUrl,
  }
}

export default function Track () {
  return (
    <div className='track'>
      <Player/>
    </div>
  )
}
